import { useMutation, useQuery } from '@apollo/client'
import {
  CREATE_SHOP_RETAILER,
  DELETE_SHOP_RETAILER,
  GET_LIST_SHOP_RETAILER,
  RECOVERY_SHOP_RETAILER,
  UPDATE_SHOP_RETAILER,
} from 'queries/shop.queries'
import { useHandleResponseAPI } from 'hooks'

function useShop(variables?: any) {
  const {
    data,
    loading,
    error: errorQuery,
    refetch,
  } = useQuery(GET_LIST_SHOP_RETAILER, {
    fetchPolicy: 'no-cache',
    variables: variables,
  })

  const [createShop, optionCreate] = useMutation(CREATE_SHOP_RETAILER)
  const [updateShop, optionUpdate] = useMutation(UPDATE_SHOP_RETAILER)
  const [deleteShop, optionDelete] = useMutation(DELETE_SHOP_RETAILER)
  const [recoveryShop, optionRecovery] = useMutation(RECOVERY_SHOP_RETAILER)

  const isLoading = loading || optionCreate.loading || optionUpdate.loading || optionRecovery.loading

  const errMsg = () => {
    // Query
    if (errorQuery || data?.listShopRetailer?.res_code === '99')
      return JSON.stringify(errorQuery || data?.listShopRetailer?.res_decs)

    // optionCreate
    if (optionCreate?.error || optionCreate.data?.createShopRetailer?.res_code === '99')
      return JSON.stringify(optionCreate?.error || optionCreate.data?.createShopRetailer?.res_decs)

    // optionUpdate
    if (optionUpdate?.error || optionUpdate.data?.updateShopRetailer?.res_code === '99')
      return JSON.stringify(optionUpdate?.error || optionUpdate.data?.updateShopRetailer?.res_decs)

    // optionDelete
    if (optionDelete?.error || optionDelete.data?.deleteShopRetailer?.res_code === '99')
      return JSON.stringify(optionDelete?.error || optionDelete.data?.deleteShopRetailer?.res_decs)

    // optionRecovery
    if (optionRecovery?.error || optionRecovery.data?.recoveryShopRetailer?.res_code === '99')
      return JSON.stringify(optionRecovery?.error || optionRecovery.data?.recoveryShopRetailer?.res_decs)
    return ''
  }

  useHandleResponseAPI({
    isLoading: isLoading,
    errMsg: errMsg(),
  })

  return {
    data: data?.listShopRetailer,
    shopLoading: loading,
    refetch,
    createShop,
    updateShop,
    deleteShop,
    recoveryShop,
  }
}

export default useShop
